import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import AvatarItem from '@atlaskit/avatar/AvatarItem';

import { TemplateCardWrapper } from './TemplateCardStyles';
import { DefaultIcon } from './TemplateIcon';
import { loadingGrey, loadingBorderRadius } from './TemplateIcon/TemplateIconConstants';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PlaceholderTitle = styled.div({
	height: '16px',
	width: '55%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundColor: loadingGrey,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: loadingBorderRadius,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PlaceholderDescription = styled.div({
	marginTop: token('space.050', '4px'),
	height: '32px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundColor: loadingGrey,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: loadingBorderRadius,
});

export const LoadingTemplateCard = () => (
	<AvatarItem
		avatar={<DefaultIcon data-testid="template-card-default-icon" />}
		isTruncationDisabled
		primaryText={<PlaceholderTitle />}
		secondaryText={<PlaceholderDescription />}
	>
		{({ ref: _, ...props }) => (
			<TemplateCardWrapper {...props} data-testid="template-card-wrapper" />
		)}
	</AvatarItem>
);
